import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export default class AddAgentForm {
  public users: string[] = [];
  public positionId: number = 0;

  public rules: { [key: string]: FormValidationFunction[] } = {
    users: [
      (v: string[]) => !!v.length || 'You have to select at least one user',
    ],
    positionId: [
      (v: number) => !!v || 'You have to select position',
    ],
  };
}
